import React, { useEffect } from 'react';
import { useQuery } from '@apollo/client';
import LoadingSpinner from '../../loading-spinner';
import ShowEmailReplyModal from './ShowEmailReplyModal';
import { getDocumentFeedbackById } from '../../../api/queries_v2';
import { useNotifications } from '../../../notifications';

type ShowEmailReplyModalProps = {
  isOpen: boolean;
  activityId: string | null;
  onClose: () => void;
};

const ShowEmailReplyModalContainer = ({ isOpen, onClose, activityId }: ShowEmailReplyModalProps) => {
  const [, { error: notifyError }] = useNotifications();
  const {
    data: emailData,
    loading: emailDataLoading,
    error: emailDataError,
  } = useQuery(getDocumentFeedbackById, {
    variables: { id: activityId! },
    skip: !activityId,
  });

  useEffect(() => {
    if (emailDataError && isOpen) {
      const errorMessage = emailDataError.message || '';
      if (errorMessage.includes("Couldn't find Document")) {
        notifyError({
          message: {
            id: 'document-not-found-error',
            defaultMessage: 'Document cannot be found',
          },
        });
        onClose();
      }
    }
  }, [emailDataError, isOpen, notifyError, onClose]);

  if (emailDataLoading) {
    return <LoadingSpinner />;
  }

  if (emailDataError) {
    return null;
  }

  return emailData ? (
    <ShowEmailReplyModal isOpen={isOpen} onClose={onClose} emailData={emailData.getDocumentFeedbackById} />
  ) : null;
};

export default ShowEmailReplyModalContainer;
